import React, { SetStateAction, useEffect, useState } from 'react'
import styled from 'styled-components'
import { ActionButton, NextButton } from '../common/CommonStyled'
import InputBoxOnChange from '../inputbox/InputBoxOnChange'
import { ModalAdSheduleAddStore } from 'src/stores/ModalStore'
import DatePickerAddEtc from './DatePickerAddEtc'
import DateRangePickerAddEtc from './DateRangePickerAddEtc'

const PageWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    border-radius: 5px;
    border: 2px dashed #06799B;
    background: #EEF6F8;
    padding: 20px;
`

const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 20px;
    font-weight: 600;

    margin-bottom: 8px;
`

const ButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;

    height: 30px;
    right: 0;
`
const LabelWarpper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 464px;
`

const LabelSpan = styled.div`
  flex: 1;
  font-size: 16px;
  font-weight: 600;
`

const ElementWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;

    width: 402px;
`
const RangeWrapper = styled.div<{ $isRange?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    background-color: white;
    height: 30px;
    min-width: 82px;
    box-sizing: border-box;
    border-radius: 2px;
    /* padding: 4px; */
    font-size: 12px;
    color: ${({ $isRange }) => ($isRange ? '#06799B' : '#545454')};
    border: 1px solid ${({ $isRange }) => ($isRange ? '#06799B' : '#D1D1D1')};
`

const RangeCheckBox = styled.input`
    width: 16px;
    height: 16px;
    margin: 0px;
`
interface Props{
    title : string
    start_date : string | null
    end_date : string | null
    setstart_date? : React.Dispatch<SetStateAction<any>>
    setend_date? : React.Dispatch<SetStateAction<any>>
    index : number
    setModify : React.Dispatch<SetStateAction<boolean>>
    defaultname: string
    set_title? : React.Dispatch<SetStateAction<any>>
}

const AddEtcModify = ({title, start_date,end_date,setstart_date,setend_date, index, setModify,defaultname, set_title}:Props) => {
    const [name,setName] = useState(defaultname)
    const [isRange, setIsRange] = useState(end_date !== '' && end_date !== undefined)
    // const startdate = ModalAdSheduleAddStore((state)=>state.etcstartdate)
    // const enddate = ModalAdSheduleAddStore((state)=>state.etcenddate)
    const updateEtc = ModalAdSheduleAddStore((state) => state.updateEtc);

    useEffect(()=>{
    },[end_date,isRange])

    const [midstart_date,setMidStart_Date] = useState(start_date)
    const [midend_date,setMidEnd_Date] = useState(end_date)

    const handleCancle = ()=>{
        setModify(false)
    }

    const handleAddEtc = (name:string,startdate:string|null,enddate:string|null)=>{
        const payload: (string | null)[] =
        enddate === null || enddate === '' ? [name, startdate] : [name, startdate, enddate];
        
        updateEtc(index, payload);
        setstart_date?.(midstart_date)
        setend_date?.(midend_date)
        setModify(false)
        set_title?.(name)
    }
    return (
        <PageWrapper>
            <TitleWrapper>
                {title}
                <ButtonWrapper>
                    <ActionButton style={{width:'60px', fontSize: '12px'}} onClick={handleCancle}>취소</ActionButton>
                    <NextButton style={{width:'60px', fontSize: '12px', height:'100%'}} onClick={()=>handleAddEtc(name,midstart_date,midend_date)}> {title ==='과정 편집' ? '완료':'추가'}</NextButton>
                </ButtonWrapper>
            </TitleWrapper>
            <LabelWarpper>
                <LabelSpan>과정명</LabelSpan>
                <ElementWrapper><InputBoxOnChange value={name} onChange={(e)=>setName(e.target.value)} placeholder='과정명' height='30px' padding='6.5px 10px' fontSize='14px'/></ElementWrapper>
            </LabelWarpper>
            <LabelWarpper>
                <LabelSpan>일정</LabelSpan>
                <ElementWrapper>
                    {isRange ? 
                    <div style={{width: '100%', height:'30px'}}>
                        <DateRangePickerAddEtc start_date={start_date} setstart_date={setMidStart_Date} end_date={end_date} setend_date={setMidEnd_Date}/>
                    </div>
                    :                    
                    <div style={{width:'144px', height:'30px'}}>
                        <DatePickerAddEtc start_date={start_date} setstart_date={setMidStart_Date}/>      
                    </div>}
                    <RangeWrapper $isRange={isRange}>
                        <RangeCheckBox type="checkbox" checked={isRange} onChange={()=>setIsRange((state)=>!state)}/>
                        기간 입력
                    </RangeWrapper>
                </ElementWrapper>
            </LabelWarpper>
        </PageWrapper>
    )
}

export default AddEtcModify